export default {
    SET_PREFERRED: 'LANGUAGE/SET_PREFERRED',
    DISMISS_TOOLTIP: 'LANGUAGE/DISMISS_TOOLTIP',
    DISMISS_OPTOUT_TOOLTIP: 'LANGUAGE/DISMISS_OPTOUT_TOOLTIP'
};
